(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.modal.upload-modal
  (:require
   [frontend.ui.component.modal-dialog.view :as modal-dialog]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.modal.event :as event]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.modal.sub :as sub]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [re-frame.core :as rf]
   [common.localization :as loc]
   [herb.core :refer [<class]]
   [reagent.core :as r]
   [ui.components.alert.view :as alert]
   [common.lp-portal-import-errors :as import-errors]
   [frontend.utils :as fu]))

(def upload-status-kws
  [:uploading
   :error
   :processing
   :complete])

(defn view
  [uploads-path on-hide]
  (let [statuses @(rf/subscribe uploads-path)]
    [modal-dialog/modal-dialog
     {:visible?     (seq statuses)
      :hide!        (fn []
                      (when on-hide
                        (rf/dispatch on-hide))
                      (rf/dispatch [::event/hide-modal uploads-path]))
      :header-label (loc/tr :lp-transfer-file-progress-title)
      :size         :sm}
     [:div
      [:div
       {:class (<class common-style/upload-files-header)}
       [:div
        {:class (<class common-style/upload-file-name)}
        (loc/tr :filename)]

       [:div
        {:class (<class common-style/upload-file-status)}
        (loc/tr :upload-status)]
       [:div
        {:class (<class common-style/upload-file-progress)}
        (loc/tr :upload-percentage)]]
      [:div
       (some->>
        statuses
        (map (fn [file-status]
               (let [status (:status file-status)]
                 ^{:key (str ::file
                             "-"
                             (some->> file-status
                                      :name))}
                 [:div
                  {:class (<class common-style/upload-file-item)}
                  [:div
                   {:class (<class common-style/upload-file-item-columns)}
                   [:div
                    {:class (<class common-style/upload-file-item-name)}
                    (or (some->> file-status
                                 :name)
                        " ")
                    [:span
                     {:class (<class common-style/upload-file-item-size)}
                     (fu/format-data-size (:size file-status))]]

                   [:div
                    {:class (<class (partial common-style/upload-file-item-status status))}
                    (loc/tr status)]
                   [:div
                    {:class (<class common-style/upload-file-item-progress)}
                    [:div
                     {:class (<class common-style/import-progress)}
                     [:div
                      {:class (<class (partial common-style/import-progress-bar
                                               status
                                               (:percentage file-status)))}]]]]
                  ;; Failure detail reads as an alert under the row, as in step 1.
                  (when (and (= :error status)
                             (or (seq (:formula-errors file-status))
                                 (:message file-status)))
                    [:div
                     {:class-name "mt-2"}
                     [alert/danger {}
                      (if-let [formula-errors (seq (:formula-errors file-status))]
                        (let [total (import-errors/total-error-count formula-errors)]
                          [:<>
                           [:div (if (= 1 total)
                                   (loc/tr :lp-import-error-formula-intro-one)
                                   (loc/tr :lp-import-error-formula-intro [total]))]
                           [:ul
                            {:class-name "list-disc pl-5 mt-1"}
                            (for [{:excel/keys [sheet function] :as group} formula-errors]
                              ^{:key (str sheet "!" function)}
                              [:li (import-errors/group-description group)])]
                           [:div
                            {:class-name "mt-2"}
                            (loc/tr :lp-import-error-formula-advice)]])
                        [:div (:message file-status)])]])])))
        (doall))]]]))
